import ProtectedRoute from "app/utils/ProtectedRoute";
import Settings from "./Settings";
import WorkspaceSetting from "./components/WorkspaceSetting";
import MemberSetting from "./components/MemberSetting";
import SettingHome from "./components/SettingHome";

import ReportTable from "../NewWorkspacePages/WorkspaceReportTable";
import AddItemPage from "../NewWorkspacePages/AddGSTINPage/AddGstin";
import UserTable from "../NewWorkspacePages/UserWorkspace/UserTable";
import WorkspaceMetaSetting from "./components/WorkspaceMetaSetting";

//eslint-disable-next-line
export default {
  path: "/settings/",
  element: (
    <ProtectedRoute>
      <Settings />
    </ProtectedRoute>
  ),
  strict: true,
  children: [
    {
      path: "/settings/workspace",
      element: <WorkspaceSetting />,
      exact: true,
    },
    {
      path: "/settings/members",
      element: <MemberSetting />,
      exact: true,
    },
    {
      path: "/settings/workspace/meta",
      element: <WorkspaceMetaSetting />,
      exact: true,
    },
    {
      path: "/settings/home",
      element: <SettingHome />,
      exact: true,
    },
    {
      path: "/settings/workspace-page",
      element: <ReportTable />,
      exact: true,
    },
    {
      path: "/settings/add-gstin",
      element: <AddItemPage />,
      exact: true,
    },
    {
      path: "/settings/user-table",
      element: <UserTable />,
      exact: true,
    },
  ],
};
